module.exports = __webpack_public_path__ + "img/register-v2.7df10ff0.svg";